export default __webpack_public_path__ + "static/media/store.155a86c4.svg";